import React from 'react';
import './styles/app.scss';

import StationsList from './components/stations-list';

function App() {
  return (
    <div className="app">
      <StationsList/>
    </div>
  );
}

export default App;
